import { Component, computed, inject } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';
import { RouterModule } from '@angular/router';
import { AppConfigurator } from '@/layout/components/app.configurator';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, AppConfigurator],
    template: ` <section class="animate-fadein animate-duration-300 animate-ease-in landing-container mx-auto min-h-[75vh] lg:min-h-screen flex flex-col items-center justify-center">
            <h1 class="title-h5 lg:title-h1 mt-8">Erro!</h1>
            <p class="body-small lg:body-large mt-2 lg:mt-4">Algo deu errado!</p>
            <a routerLink="/" class="body-button bg-red-600 w-fit mt-8 hover:bg-red-500 px-4">Voltar para o Dashboard</a>
        </section>
        <button class="layout-config-button config-link" (click)="layoutService.toggleConfigSidebar()">
            <i class="pi pi-cog"></i>
        </button>
        <app-configurator />`
})
export class Notfound {
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
